import { createRouter, createWebHistory } from 'vue-router';
import { activeMenus } from '../store/navActiveMenu';
import { authChecker } from '../store/authChecker';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'active',
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth'
          });
        }, 1000);
      });
    }
  }
});

// router.beforeEach((to, from, next) => {
//   activeMenus.setAllMenusAsInactive();
//   activeMenus.setActiveMenu(to.name);
//   var permissions = localStorage.getItem('userPermission');
//   var roleName = localStorage.getItem('userPermission');
//   var permission = to.name;
//   const record = to.matched.some((record) => record.meta.requiresAuth);
//   if (record) {
//     if (localStorage.getItem('token') == null) {
//       next({
//         path: '/',
//         params: { nextUrl: to.fullPath }
//       });
//     } else {
//       if (to.name === 'trip-create' || to.name === 'partner-permission-list') {
//         if (roleName === 'Internal User') {
//           next();
//         }
//         next();
//       } else {
//         if (permissions.includes(permission)) {
//           next();
//         } else {
//           next({
//             path: '/access-denied',
//             params: { nextUrl: to.fullPath }
//           });
//         }
//       }
//     }
//   } else if (to.matched.some((record) => record.meta.guest)) {
//     if (localStorage.getItem('token') == null) {
//       next();
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });
router.beforeEach((to, from, next) => {
  activeMenus.setAllMenusAsInactive();
  activeMenus.setActiveMenu(to.name);
  var permissions = null;
  if (localStorage.getItem('userPermission')) {
    permissions = localStorage.getItem('userPermission').split(',');
  }
  var permission = to.name;
  const record = to.matched.some((record) => record.meta.requiresAuth);
  if (to.name === 'trip-create-external') {
    if (to.params.token) {
      authChecker.checkAuth(to.params.token, (valid) => {
        if (valid) {
          next();
        }
      });
    }
  } else if (record) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/',
        params: { nextUrl: to.fullPath }
      });
    } else {
      if (permissions.includes(permission)) {
        next();
      } else {
        next({
          path: '/access-denied',
          params: { nextUrl: to.fullPath }
        });
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next();
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
